import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../api/ApiRoutes";
import type { GamePassUserEnrollmentRecord } from "../../types/gamePass";
import { getPrivateInstance } from "../_privateInstance";
import { retryOnTransientErrors } from "./queryUtils";
import { normalizeUserEnrollmentsResponse } from "./userEnrollmentsMappers";

const buildUserEnrollmentsUrl = (userId: string): string =>
  API_ROUTES.GET_GAME_PASS_USER_ENROLLMENTS.replace("{user_id}", userId);

const fetchUserEnrollments = async (
  userId: string,
): Promise<ReadonlyArray<GamePassUserEnrollmentRecord>> => {
  const response = await getPrivateInstance().get(buildUserEnrollmentsUrl(userId));
  return normalizeUserEnrollmentsResponse(response.data);
};

type UseGetUserEnrollmentsOptions = {
  enabled?: boolean;
};

export const useGetUserEnrollments = (
  userId?: string,
  options?: UseGetUserEnrollmentsOptions,
): UseQueryResult<ReadonlyArray<GamePassUserEnrollmentRecord>, Error> =>
  useQuery<ReadonlyArray<GamePassUserEnrollmentRecord>, Error>({
    queryKey: ["game-pass", "users", "enrollments", userId ?? ""],
    queryFn: () => fetchUserEnrollments(userId!),
    enabled: Boolean(userId) && (options?.enabled ?? true),
    staleTime: 1000 * 30,
    refetchOnWindowFocus: false,
    retry: retryOnTransientErrors,
  });

export { fetchUserEnrollments };
